import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { NzTableModule } from 'ng-zorro-antd/table';
import { ExpEditorModule } from '../exp-editor/exp-editor.module';
import { EditableTableComponent } from './editable-table.component';
import { I18nInputModule } from '../config-editor2/i18n-input/i18n-input.module';

@NgModule({
  declarations: [
    EditableTableComponent,
  ],
  imports: [
    CommonModule,
    NzTableModule,
    TranslateModule,
    FormsModule,
    ExpEditorModule,
    I18nInputModule
  ],
  exports: [
    EditableTableComponent,
  ]
})
export class EditableTableModule { }
